/**
 * Dynamically updates `alt` text based on screen size for accessibility & SEO.
 * Uses `data-alt` attributes on <source> elements and updates automatically on load and resize.
 * Ensures correct `alt` text is applied when switching between mobile & desktop images.
 */

function media() {
  return {
    init() {
      this.updateAltText();

      let resizeTimeout;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          requestAnimationFrame(() => this.updateAltText());
        }, 150);
      });
    },

    updateAltText() {
      document.querySelectorAll(".responsive-picture").forEach((picture) => {
        const imgElement = picture.querySelector("img");
        if (!imgElement) return;

        const sources = picture.querySelectorAll("source");
        let newAlt = imgElement.getAttribute("alt") || "";

        sources.forEach((source) => {
          if (!window.matchMedia(source.media).matches) return;

          const sourceAlt = source.getAttribute("data-alt");
          if (!sourceAlt || sourceAlt.trim() === "") return;

          newAlt = sourceAlt;
        });

        if (imgElement.getAttribute("alt") !== newAlt) {
          imgElement.setAttribute("alt", newAlt);
        }
      });
    }
  };
}

export default media;
